import { render, staticRenderFns } from "./news-room.vue?vue&type=template&id=70de0b59&"
import script from "./news-room.vue?vue&type=script&lang=js&"
export * from "./news-room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports